export var RegionKey;
(function (RegionKey) {
    RegionKey["Riga"] = "riga";
    RegionKey["Kurzeme"] = "kurzeme";
    RegionKey["Latgale"] = "latgale";
    RegionKey["Zemgale"] = "zemgale";
    RegionKey["Vidzeme"] = "vidzeme";
})(RegionKey || (RegionKey = {}));
